import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getInvoiceById,
  getInvoiceByPatientId,
} from "../../../store/slices/invoiceSlice";
import { Button } from "react-bootstrap";
import Select from "react-select";
import { getaccountType } from "../../../store/slices/accountType";
import { getBankListSlice } from "../../../store/slices/bankSlice";
import { doSalesSlice, resetMessage } from "../../../store/slices/sales";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import styles from "./InvoiceForm.module.scss";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";

const InvoiceForm = () => {
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { invoiceInFo, allPatientInvoice } = useSelector(
    (state) => state.invoice
  );
  const [error, setError] = useState("");
  const [paidAmountError, setPaidAmountError] = useState("");
  const { accountType } = useSelector((state) => state.accountType);
  const { bank } = useSelector((state) => state.bank);
  const { token } = useSelector((state) => state.auth);
  const [isHeaderCheckboxDisabled, setIsHeaderCheckboxDisabled] =
    React.useState(false);
  const dispatch = useDispatch();
  const invoiceId = sessionStorage.getItem("invoiceId");

  const clinicId =clinicInfo?.[0]?.clinicId ||null;

  const [formData, setFormData] = useState({
    clinicId: "",
    appointmentId: [invoiceInFo?.appointmentDetails?.id],
    invoiceId: [invoiceInFo?._id],
    receiptId: "",
    accountType: null,
    bank: null,
    discount: 0,
    paidAmount: 0,
    totalAmount: 0,
    totalAfterDiscount: 0,
    dueAmount: 0,
    discountType: "normal",
  });

  useEffect(() => {
    if (invoiceInFo) {
      setFormData((prevData) => ({
        ...prevData,
        appointmentId: [invoiceInFo?.appointmentDetails?.id],
        invoiceId: [invoiceInFo?._id],
      }));
    }
  }, [invoiceInFo]);

  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
  const { createSalesSuccessMessage, createSalesErrorMessage } = useSelector(
    (state) => state.sales
  );

  const [selectedRows, setSelectedRows] = useState(new Set());
  const clientId =
    invoiceInFo?.isClient === "Yes" ? invoiceInFo?.clientId : null;
  const patientId =
    invoiceInFo?.isClient === "No"
      ? invoiceInFo?.appointmentDetails?.patientId?._id
      : null;

  useEffect(() => {
    dispatch(getaccountType({ status: ["Active"], token }));
    dispatch(
      getBankListSlice({
        status: ["Active"],
        clinicId,
        token,
      })
    );
    dispatch(
      getInvoiceByPatientId({
        clientId,
        patientId,
        clinicId,
        token,
      })
    );
  }, [dispatch, clinicId, invoiceInFo, clientId, patientId, token]);

  useEffect(() => {
    if (invoiceId) {
      dispatch(getInvoiceById({ id: invoiceId, token }));
    }
  }, [dispatch, invoiceId, token]);

  useEffect(() => {
    showTostifyMessageAndReset(
      createSalesSuccessMessage,
      showToastifySuccess,
      resetMessage
    );
    showTostifyMessageAndReset(
      createSalesErrorMessage,
      showToastifyError,
      resetMessage
    );
  }, [
    createSalesSuccessMessage,
    createSalesErrorMessage,
    showTostifyMessageAndReset,
  ]);

  useEffect(() => {
    if (!invoiceInFo) return;

    // 🔹 Helper to find tax (supports nested tax fields like item[someId].tax)
    const getTaxFromItem = (item) => {
      if (!item || typeof item !== "object") return 0;

      // direct tax
      if (typeof item?.tax === "number") return item.tax;

      // check nested objects
      for (const key of Object.keys(item)) {
        if (item[key] && typeof item[key] === "object" && "tax" in item[key]) {
          return Number(item[key].tax) || 0;
        }
      }

      return 0;
    };

    const healthScreeningItems =
      invoiceInFo?.appointmentDetails?.healthScreeningDetails || [];
    const physiotherapyItems =
      invoiceInFo?.appointmentDetails?.physiotherapyService || [];
    const radioServicesItems =
      invoiceInFo?.appointmentDetails?.radioServices || [];
    const healthPackageItems =
      invoiceInFo?.appointmentDetails?.healthPackageDetails || [];

    if (healthScreeningItems.length > 0) {
      const totalAmount = healthScreeningItems.reduce((total, item) => {
        const mrp = Number(item?.healthScreeningAmount) || 0;
        const taxAmount = mrp * (Number(getTaxFromItem(item)) / 100);
        return total + mrp + taxAmount;
      }, 0);

      const totalTax = healthScreeningItems.reduce(
        (total, item) => total + getTaxFromItem(item),
        0
      );
      const cgstSgst = totalTax / 2;

      setFormData((prev) => ({
        ...prev,
        totalAmount,
        totalAfterDiscount: totalAmount,
        dueAmount: totalAmount,
        cgst: cgstSgst,
        sgst: cgstSgst,
      }));
    } else if (physiotherapyItems.length > 0) {
      // Physiotherapy Services Exist
      const totalAmount = physiotherapyItems.reduce((total, item) => {
        const mrp = Number(item?.price) || 0;
        const taxAmount = mrp * (getTaxFromItem(item) / 100);
        return total + mrp + taxAmount;
      }, 0);

      const totalTax = physiotherapyItems.reduce(
        (total, item) => total + getTaxFromItem(item),
        0
      );
      const cgstSgst = totalTax / 2;

      setFormData((prev) => ({
        ...prev,
        totalAmount,
        totalAfterDiscount: totalAmount,
        dueAmount: totalAmount,
        cgst: cgstSgst,
        sgst: cgstSgst,
      }));
    } else if (radioServicesItems.length > 0) {
      const totalAmount = radioServicesItems.reduce((total, item) => {
        const mrp = Number(item?.totalAmount) || 0;
        const taxAmount = mrp * (getTaxFromItem(item) / 100);
        return total + mrp + taxAmount;
      }, 0);

      const totalTax = radioServicesItems.reduce(
        (total, item) => total + getTaxFromItem(item),
        0
      );
      const cgstSgst = totalTax / 2;

      setFormData((prev) => ({
        ...prev,
        totalAmount,
        totalAfterDiscount: totalAmount,
        dueAmount: totalAmount,
        cgst: cgstSgst,
        sgst: cgstSgst,
      }));
    } else if (healthPackageItems.length > 0) {
      // Health Package Details Exist
      const totalAmount = healthPackageItems.reduce((total, item) => {
        const mrp = Number(item?.healthPackageAmount) || 0;
        const taxAmount = mrp * (getTaxFromItem(item) / 100);
        return total + mrp + taxAmount;
      }, 0);

      const totalTax = healthPackageItems.reduce(
        (total, item) => total + getTaxFromItem(item),
        0
      );
      const cgstSgst = totalTax / 2;

      setFormData((prev) => ({
        ...prev,
        totalAmount,
        totalAfterDiscount: totalAmount,
        dueAmount: totalAmount,
        cgst: cgstSgst,
        sgst: cgstSgst,
      }));
    } else {
      // No Health Screening or Physiotherapy Services, Use Other Services
      const allItems = [
        ...(invoiceInFo?.appointmentDetails?.tests || []),
        ...(invoiceInFo?.appointmentDetails?.profiles || []),
        ...(invoiceInFo?.appointmentDetails?.consultationDetails || []),
        ...(invoiceInFo?.appointmentDetails?.skinServices || []),
        ...(invoiceInFo?.appointmentDetails?.hairServices || []),
        ...(invoiceInFo?.appointmentDetails?.dentalServices || []),
        ...(invoiceInFo?.appointmentDetails?.generalServices || []),
      ];

      const totalAmount = allItems.reduce((total, item) => {
        const mrp = Number(item?.price) || 0;
        const taxRate = getTaxFromItem(item);
        const amount = mrp * (taxRate / 100);

        if (item?.totalAmount) {
          return total + Number(item.totalAmount);
        }

        return total + mrp + amount;
      }, 0);

      const totalTax = allItems.reduce(
        (total, item) => total + getTaxFromItem(item),
        0
      );
      const cgstSgst = totalTax / 2;

      setFormData((prev) => ({
        ...prev,
        totalAmount,
        totalAfterDiscount: totalAmount,
        dueAmount: totalAmount,
        cgst: cgstSgst,
        sgst: cgstSgst,
      }));
    }
  }, [invoiceInFo]);

  const handleChange = (e, field = null) => {
    setFormData((prev) => ({
      ...prev,
      [field]: {
        value: e?.value || "",
        label: e?.label || "",
      },
    }));
    if (field === "accountType") {
      setFormData((prev) => ({
        ...prev,
        bank: null,
      }));
    }
  };

  const filteredBanks = formData.accountType
    ? bank?.filter(
        (b) =>
          b?.accountType && b?.accountType._id === formData?.accountType?.value
      )
    : [];

  const handlePaidAmountFocus = () => {
    setFormData((prev) => {
      const paidAmount = Number(prev.totalAfterDiscount) || 0;
      return {
        ...prev,
        paidAmount,
        dueAmount: 0,
      };
    });
    setPaidAmountError("");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updatedData = {
        ...prev,
        [name]:
          name === "discount" || name === "paidAmount"
            ? value === ""
              ? ""
              : parseFloat(value)
            : value,
      };

      const discountType =
        name === "discountType" ? value : prev.discountType || "normal";
      const discountValue =
        name === "discount"
          ? value === ""
            ? 0
            : parseFloat(value)
          : prev.discount || 0;
      const paidAmount =
        name === "paidAmount"
          ? value === ""
            ? 0
            : parseFloat(value)
          : prev.paidAmount || 0;
      const totalAmount = prev.totalAmount;

      let appliedDiscount = 0;

      if (discountType === "percentage") {
        appliedDiscount = (totalAmount * discountValue) / 100;
      } else {
        appliedDiscount = discountValue;
      }

      const totalAfterDiscount = Math.max(totalAmount - appliedDiscount, 0);
      const dueAmount = Math.max(totalAfterDiscount - paidAmount, 0);

      if (appliedDiscount > totalAmount) {
        setError("Discount cannot be greater than total amount.");
        return prev;
      } else {
        setError("");
      }

      if (paidAmount > totalAfterDiscount) {
        setPaidAmountError(
          "Paid amount cannot be greater than total after discount."
        );
        return prev;
      } else {
        setPaidAmountError("");
      }

      updatedData.totalAfterDiscount = totalAfterDiscount;
      updatedData.dueAmount = dueAmount;

      return updatedData;
    });
  };
  // This code handles the calculation logic for multiple totals and multiple payments
  const getTotalAmountWithTax = (row) => {
    const details = row?.appointmentDetails || {};
    const {
      tests = [],
      profiles = [],
      healthScreeningDetails = [],
      radioServices = [],
      physiotherapyService = [],
      healthPackageDetails = [],
      hairServices = [],
      generalServices = [],
      skinServices = [],
      dentalServices = [],
      consultationDetails = [],
    } = details;

    if (healthScreeningDetails?.length > 0) {
      const item = healthScreeningDetails[0];
      const amount = Number(item?.healthScreeningAmount || 0);
      const tax = Number(item?.tax || 0);
      return amount + (amount * tax) / 100;
    } else if (radioServices?.length > 0) {
      const total = radioServices.reduce((sum, service) => {
        const details = service?.radiologyServiceInfo?.serviceDetails || [];

        const serviceTotal = details.reduce((innerSum, detail) => {
          const base = Number(detail?.price || 0);
          const tax = Number(detail?.tax || service?.tax || 0);
          return innerSum + base + (base * tax) / 100;
        }, 0);

        return sum + serviceTotal;
      }, 0);

      return total;
    } else if (physiotherapyService?.length > 0) {
      return physiotherapyService?.reduce((sum, item) => {
        const price = Number(item?.price || 0);
        const tax = Number(item?.physioId?.tax || 0);
        return sum + price + (price * tax) / 100;
      }, 0);
    } else if (healthPackageDetails?.length > 0) {
      return healthPackageDetails?.reduce((sum, item) => {
        const price = Number(item?.healthPackageAmount || 0);
        const tax = Number(item?.tax || 0);
        return sum + price + (price * tax) / 100;
      }, 0);
    } else if (hairServices?.length > 0) {
      return hairServices?.reduce((sum, item) => {
        const price = Number(item?.pt_price || 0);
        const tax = Number(item?.tax || 0);
        return sum + price + (price * tax) / 100;
      }, 0);
    } else if (generalServices?.length > 0) {
      return generalServices?.reduce((sum, item) => {
        const price = Number(item?.pt_price || 0);
        const tax = Number(item?.tax || 0);
        return sum + price + (price * tax) / 100;
      }, 0);
    } else if (skinServices?.length > 0) {
      return skinServices?.reduce((sum, item) => {
        const price = Number(item?.pt_price || 0);
        const tax = Number(item?.tax || 0);
        return sum + price + (price * tax) / 100;
      }, 0);
    } else if (dentalServices?.length > 0) {
      return dentalServices?.reduce((sum, item) => {
        const price = Number(item?.pt_price || 0);
        const tax = Number(item?.tax || 0);
        return sum + price + (price * tax) / 100;
      }, 0);
    } else if (consultationDetails?.length > 0) {
      return consultationDetails?.reduce((sum, item) => {
        const price = Number(item?.price || 0);
        return sum + price;
      }, 0);
    } else {
      const testAmt = tests?.reduce((sum, item) => {
        const price = Number(item?.price || 0);
        const tax = Number(item?.testId?.tax || 0);
        return sum + price + (price * tax) / 100;
      }, 0);

      const profileAmt = profiles?.reduce((sum, item) => {
        const price = Number(item?.price || 0);
        const tax = Number(item?.profileId?.tax || 0);
        return sum + price + (price * tax) / 100;
      }, 0);

      return testAmt + profileAmt;
    }
  };

  const handleHeaderChange = (e) => {
    const filteredInvoices = allPatientInvoice.filter(
      (row) => row.invoiceId !== invoiceInFo._id
    );

    if (e.target.checked) {
      const allRowIds = filteredInvoices?.map((row) => row?.invoiceId);
      const allAppointmentIds = filteredInvoices.map(
        (row) => row?.appointmentDetails?.id
      );

      const totalAmountWithTax = filteredInvoices?.reduce((acc, row) => {
        return acc + getTotalAmountWithTax(row);
      }, 0);

      setSelectedRows(new Set(allRowIds));
      setFormData((prevFormData) => ({
        ...prevFormData,
        totalAmount: Number(prevFormData.totalAmount || 0) + totalAmountWithTax,
        totalAfterDiscount:
          Number(prevFormData.totalAfterDiscount || 0) + totalAmountWithTax,
        dueAmount: Number(prevFormData.dueAmount || 0) + totalAmountWithTax,
        appointmentId: [
          ...new Set([...prevFormData.appointmentId, ...allAppointmentIds]),
        ],
        invoiceId: [...new Set([...prevFormData.invoiceId, ...allRowIds])],
      }));

      setIsHeaderCheckboxDisabled(true);
    } else {
      const totalAmountWithTax = filteredInvoices.reduce((acc, row) => {
        return acc + getTotalAmountWithTax(row);
      }, 0);

      setSelectedRows(new Set());
      setFormData((prevFormData) => ({
        ...prevFormData,
        totalAmount: Number(prevFormData.totalAmount || 0) - totalAmountWithTax,
        totalAfterDiscount:
          Number(prevFormData.totalAfterDiscount || 0) - totalAmountWithTax,
        dueAmount: Number(prevFormData.dueAmount || 0) - totalAmountWithTax,
        appointmentId: prevFormData.appointmentId.filter(
          (id) =>
            !filteredInvoices.some((row) => row?.appointmentDetails?.id === id)
        ),
        invoiceId: prevFormData.invoiceId.filter(
          (id) => !filteredInvoices.some((row) => row.invoiceId === id)
        ),
      }));

      setIsHeaderCheckboxDisabled(false);
    }
  };

  const handleRowChange = (invoiceId, event) => {
    const isChecked = event.target.checked;

    setSelectedRows((prev) => {
      const updatedRows = new Set(prev);
      const selectedInvoice = allPatientInvoice.find(
        (row) => row.invoiceId === invoiceId
      );

      const totalWithTax = getTotalAmountWithTax(selectedInvoice);

      if (isChecked) {
        updatedRows.add(invoiceId);
        setFormData((prevFormData) => ({
          ...prevFormData,
          totalAmount: Number(prevFormData.totalAmount || 0) + totalWithTax,
          totalAfterDiscount:
            Number(prevFormData.totalAfterDiscount || 0) + totalWithTax,
          dueAmount: Number(prevFormData.dueAmount || 0) + totalWithTax,
          appointmentId: [
            ...new Set([
              ...prevFormData.appointmentId,
              selectedInvoice?.appointmentDetails?.id,
            ]),
          ],
          invoiceId: [...new Set([...prevFormData.invoiceId, invoiceId])],
        }));
      } else {
        updatedRows.delete(invoiceId);
        setFormData((prevFormData) => ({
          ...prevFormData,
          totalAmount: Number(prevFormData.totalAmount || 0) - totalWithTax,
          totalAfterDiscount:
            Number(prevFormData.totalAfterDiscount || 0) - totalWithTax,
          dueAmount: Number(prevFormData.dueAmount || 0) - totalWithTax,
          appointmentId: prevFormData.appointmentId.filter(
            (id) => id !== selectedInvoice?.appointmentDetails?.id
          ),
          invoiceId: prevFormData.invoiceId.filter((id) => id !== invoiceId),
        }));
      }

      setIsHeaderCheckboxDisabled(updatedRows.size > 0);
      return updatedRows;
    });
  };
  //

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.paidAmount || formData.paidAmount === 0) {
      setPaidAmountError("Paid amount is required.");
      return;
    } else {
      setPaidAmountError("");
    }

    const combinedItems = [
      ...(invoiceInFo?.appointmentDetails?.tests || []),
      ...(invoiceInFo?.appointmentDetails?.profiles || []),
      ...(invoiceInFo?.appointmentDetails?.consultationDetails || []),
    ];

    const localFormData = {
      token,
      clinicId,
      appointmentId: formData?.appointmentId,
      invoiceId: formData?.invoiceId,
      receiptId: invoiceInFo?.receiptId?.receiptId,
      accountType: formData?.accountType?.value,
      bank: formData.bank?.value,
      totalPrice: formData?.totalAmount,
      discountPrice:
        formData?.discountType === "percentage"
          ? (formData?.totalAmount * formData?.discount) / 100
          : formData?.discount,
      paymentDetails: [
        {
          paidAmount: formData?.paidAmount,
          dueAmount: formData?.dueAmount,
          receivedBy: clinicInfo[0]?.userId?._id,
        },
      ],
      createdBy: clinicInfo[0]?.createdBy,
      items: combinedItems?.map((item) => ({
        name: item?.testName || item?.profileName || item?.serviceName,
        price: item?.client_price || item?.pt_price,
        tax: item?.tax,
      })),
    };

    try {
      const res = await dispatch(doSalesSlice(localFormData, token));
      if (!res.error) {
        setFormData((prevData) => ({
          ...prevData,
          paidAmount: 0,
          discount: 0,
          discountType: "normal",
        }));
        setSelectedRows(new Set());
        dispatch(getInvoiceById({ id: invoiceId, token }));
      } else {
        console.error("Submission failed:", res.error.message);
      }
    } catch (error) {
      console.error("Submit exception:", error);
    }
  };
  const isAllSelected =
    allPatientInvoice?.length > 0 &&
    selectedRows.size === allPatientInvoice.length;
  const shouldHideFields =
    invoiceInFo?.paymentStatus === "PAID" ||
    invoiceInFo?.paymentStatus === "DUE";
  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-header">
            Invoice <span className="bold-text">{invoiceInFo?.date}</span>
            <span className="float-end">
              <span className="bold-text">Status:</span>{" "}
              {invoiceInFo?.paymentStatus}
            </span>
          </div>
          <div className="card-body">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="basic-form">
                    <form onSubmit={(e) => e.preventDefault()}>
                      <div className="row">
                        <div className="form-group mb-3 col-md-6">
                          <label>Name</label>
                          <input
                            type="text"
                            className="form-control"
                            value={invoiceInFo?.appointmentDetails?.patientName}
                            readOnly
                          />
                        </div>
                        <div className="form-group mb-3 col-md-6">
                          <label>Invoice Number</label>
                          <input
                            type="text"
                            className="form-control"
                            value={invoiceInFo?.invoiceId}
                            readOnly
                          />
                        </div>
                        <div className="form-group mb-3 col-md-6">
                          <label className="col-form-label">
                            Account Type:
                          </label>
                          <Select
                            value={formData?.accountType}
                            placeholder="Select Account Type"
                            options={accountType?.map((account) => ({
                              value: account?._id,
                              label: account?.name,
                            }))}
                            onChange={(selectedOption) =>
                              handleChange(selectedOption, "accountType")
                            }
                          />
                        </div>
                        <div className="form-group mb-3 col-md-6">
                          <label className="col-form-label">Bank:</label>
                          <Select
                            required
                            value={formData.bank}
                            placeholder="Select Bank"
                            options={filteredBanks?.map((b) => ({
                              value: b._id,
                              label: b.name,
                            }))}
                            onChange={(selectedOption) =>
                              handleChange(selectedOption, "bank")
                            }
                            isDisabled={!formData.accountType}
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th className="right">MRP</th>
                    <th className="center">Tax</th>
                    <th className="right">SGST</th>
                    <th className="center">CGST</th>
                    <th className="right">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {invoiceInFo?.appointmentDetails?.healthPackageDetails
                    ?.length > 0 ? (
                    invoiceInFo.appointmentDetails.healthPackageDetails.map(
                      (pkg) => {
                        const mrp = parseFloat(pkg?.healthPackageAmount) || 0;
                        const tax = parseFloat(pkg?.tax ?? 0);
                        const amount = (mrp * tax) / 100;
                        const remainingMRP = mrp + amount;

                        const sgst = tax / 2;
                        const cgst = tax / 2;
                        return (
                          <tr key={`package-${pkg?._id}`}>
                            <td className="left">{pkg?.healthPackageName}</td>
                            <td className="right">{mrp}</td>
                            <td className="center">{tax}%</td>
                            <td className="right">{sgst}%</td>
                            <td className="right">{cgst}%</td>
                            <td className="right">{remainingMRP}</td>
                          </tr>
                        );
                      }
                    )
                  ) : invoiceInFo?.appointmentDetails?.healthScreeningDetails
                      ?.length > 0 ? (
                    invoiceInFo.appointmentDetails.healthScreeningDetails.map(
                      (screening) => {
                        const mrp =
                          parseFloat(screening?.healthScreeningAmount) || 0;
                        const tax = parseFloat(screening?.tax ?? 0);
                        const amount = (mrp * tax) / 100;
                        const remainingMRP = mrp + amount;

                        const sgst = tax / 2;
                        const cgst = tax / 2;
                        return (
                          <tr key={`screening-${screening?._id}`}>
                            <td className="left">
                              {screening?.healthScreeningName}
                            </td>
                            <td className="right">{mrp}</td>
                            <td className="center">{tax}%</td>
                            <td className="right">{sgst}%</td>
                            <td className="right">{cgst}%</td>
                            <td className="right">{remainingMRP}</td>
                          </tr>
                        );
                      }
                    )
                  ) : (
                    <>
                      {invoiceInFo?.appointmentDetails?.tests?.map((item) => {
                        const isClient = invoiceInFo?.isClient === "Yes";
                        const mrp = parseFloat(item?.price);

                        const tax = parseFloat(item?.testId?.tax ?? 0);
                        const amount = (mrp * tax) / 100;
                        const remainingMRP = mrp + amount;

                        const sgst = tax / 2;
                        const cgst = tax / 2;

                        return (
                          <tr key={`test-${item?.testId?.testName}`}>
                            <td className="left">{item?.testId?.testName}</td>
                            <td className="right">{mrp}</td>
                            <td className="center">{item?.testId?.tax}%</td>
                            <td className="right">{sgst}%</td>
                            <td className="right">{cgst}%</td>
                            <td className="right">{remainingMRP}</td>
                          </tr>
                        );
                      })}

                      {invoiceInFo?.appointmentDetails?.profiles?.map(
                        (profile) => {
                          const isClient = invoiceInFo?.isClient === "Yes";
                          const mrp = profile?.price;

                          const tax = parseFloat(profile?.profileId?.tax ?? 0);
                          const amount = (mrp * tax) / 100;
                          const remainingMRP = mrp + amount;

                          const sgst = tax / 2;
                          const cgst = tax / 2;

                          return (
                            <tr
                              key={`profile-${profile?.profileId?.profileName}`}
                            >
                              <td className="left">
                                {profile?.profileId?.profileName}
                              </td>
                              <td className="right">{profile?.price}</td>
                              <td className="center">
                                {profile?.profileId?.tax}%
                              </td>
                              <td className="right">{sgst}%</td>
                              <td className="right">{cgst}%</td>
                              <td className="right">{remainingMRP}</td>
                            </tr>
                          );
                        }
                      )}

                      {invoiceInFo?.appointmentDetails?.consultationDetails?.map(
                        (consultation) => {
                          const physicianName =
                            invoiceInFo?.appointment?.physicianId?.userId
                              ?.name || "N/A";
                          const mrp = parseFloat(consultation?.price) || 0;
                          const tax = parseFloat(consultation?.tax ?? 0);
                          const amount = (mrp * tax) / 100;
                          const remainingMRP = mrp + amount;

                          const sgst = tax / 2;
                          const cgst = tax / 2;

                          return (
                            <tr key={`consultation-${consultation?._id}`}>
                              <td className="left">{physicianName}</td>
                              <td className="right">{mrp}</td>
                              <td className="center">{tax}%</td>
                              <td className="right">{sgst}%</td>
                              <td className="right">{cgst}%</td>
                              <td className="right">{remainingMRP}</td>
                            </tr>
                          );
                        }
                      )}

                      {invoiceInFo?.appointmentDetails?.physiotherapyService?.map(
                        (service) => {
                          const isClient = invoiceInFo?.isClient === "Yes";
                          const mrp = parseFloat(service.price) || 0;
                          const tax = parseFloat(service?.physioId?.tax ?? 0);
                          const amount = (mrp * tax) / 100;
                          const remainingMRP = mrp + amount;

                          const sgst = tax / 2;
                          const cgst = tax / 2;

                          return (
                            <tr key={`physio-${service?._id}`}>
                              <td className="left">
                                {service?.physioId?.serviceDetailName}
                              </td>
                              <td className="right">{mrp}</td>
                              <td className="center">
                                {service?.physioId?.tax}%
                              </td>
                              <td className="right">{sgst}%</td>
                              <td className="right">{cgst}%</td>

                              <td className="right">{remainingMRP}</td>
                            </tr>
                          );
                        }
                      )}

                      {invoiceInFo?.appointmentDetails?.skinServices?.map(
                        (service) => {
                          const isClient = invoiceInFo?.isClient === "Yes";
                          const mrp = parseFloat(service?.price) || 0;
                          const tax = parseFloat(service?.skinId?.tax ?? 0);
                          const amount = (mrp * tax) / 100;
                          const remainingMRP = mrp + amount;

                          const sgst = tax / 2;
                          const cgst = tax / 2;

                          return (
                            <tr key={`skin-${service?._id}`}>
                              <td className="left">{service?.skinId?.serviceName}</td>
                              <td className="right">{mrp}</td>
                              <td className="center">{tax}%</td>
                              <td className="right">{sgst}%</td>
                              <td className="right">{cgst}%</td>
                              <td className="right">{remainingMRP}</td>
                            </tr>
                          );
                        }
                      )}

                      {invoiceInFo?.appointmentDetails?.dentalServices?.map(
                        (service) => {
                          const isClient = invoiceInFo?.isClient === "Yes";
                          const mrp = parseFloat(service?.price) || 0;
                          const tax = parseFloat(service?.dentalId?.tax ?? 0);
                          const amount = (mrp * tax) / 100;
                          const remainingMRP = mrp + amount;

                          const sgst = tax / 2;
                          const cgst = tax / 2;

                          return (
                            <tr key={`dental-${service?._id}`}>
                              <td className="left">{service?.dentalId?.serviceName}</td>
                              <td className="right">{mrp}</td>
                              <td className="center">{tax}%</td>
                              <td className="right">{sgst}%</td>
                              <td className="right">{cgst}%</td>

                              <td className="right">{remainingMRP}</td>
                            </tr>
                          );
                        }
                      )}
                      {invoiceInFo?.appointmentDetails?.hairServices?.map(
                        (service) => {
                          const isClient = invoiceInFo?.isClient === "Yes";
                          const mrp = parseFloat(service?.price) || 0;
                          const tax = parseFloat(service?.hairId?.tax ?? 0);
                          const amount = (mrp * tax) / 100;
                          const remainingMRP = mrp + amount;

                          const sgst = tax / 2;
                          const cgst = tax / 2;

                          return (
                            <tr key={`dental-${service?._id}`}>
                              <td className="left">{service?.hairId?.serviceName}</td>
                              <td className="right">{mrp}</td>
                              <td className="center">{tax}%</td>
                              <td className="right">{sgst}%</td>
                              <td className="right">{cgst}%</td>
                              <td className="right">{remainingMRP}</td>
                            </tr>
                          );
                        }
                      )}
                      {invoiceInFo?.appointmentDetails?.generalServices?.map(
                        (service) => {
                          const isClient = invoiceInFo?.isClient === "Yes";
                          const mrp =
                            parseFloat(service?.price) || 0;
                          const tax = parseFloat(service?.generalId?.tax ?? 0);
                          const amount = (mrp * tax) / 100;
                          const remainingMRP = mrp + amount;

                          const sgst = tax / 2;
                          const cgst = tax / 2;

                          return (
                            <tr key={`dental-${service?._id}`}>
                              <td className="left">{service?.generalId?.serviceName}</td>
                              <td className="right">{mrp}</td>
                              <td className="center">{tax}%</td>
                              <td className="right">{sgst}%</td>
                              <td className="right">{cgst}%</td>
                              <td className="right">{remainingMRP}</td>
                            </tr>
                          );
                        }
                      )}

                      {invoiceInFo?.appointmentDetails?.radioServices?.map(
                        (service) => {
                          return (
                            <>
                              {service?.radiologyServiceInfo?.serviceDetails?.map(
                                (detail, idx) => {
                                  const mrp = parseFloat(detail?.price) || 0;
                                  const tax = parseFloat(
                                    detail?.radioId?.tax ?? 0
                                  );
                                  const amount = (mrp * tax) / 100;
                                  const remainingMRP = mrp + amount;

                                  const sgst = tax / 2;
                                  const cgst = tax / 2;

                                  return (
                                    <tr key={idx}>
                                      <td className="left">
                                        {detail?.radioId?.serviceDetailsName}
                                      </td>
                                      <td className="right">{mrp}</td>
                                      <td className="center">{tax}%</td>
                                      <td className="right">{sgst}%</td>
                                      <td className="right">{cgst}%</td>
                                      <td className="right">{remainingMRP}</td>
                                    </tr>
                                  );
                                }
                              )}
                            </>
                          );
                        }
                      )}

                      {!invoiceInFo?.appointmentDetails?.tests?.length &&
                        !invoiceInFo?.appointmentDetails?.profiles?.length &&
                        !invoiceInFo?.appointmentDetails?.consultationDetails
                          ?.length &&
                        !invoiceInFo?.appointmentDetails?.skinServices
                          ?.length &&
                        !invoiceInFo?.appointmentDetails?.radioServices
                          ?.length &&
                        !invoiceInFo?.appointmentDetails?.dentalServices
                          ?.length &&
                        !invoiceInFo?.appointmentDetails?.hairServices
                          ?.length &&
                        !invoiceInFo?.appointmentDetails?.generalServices
                          ?.length &&
                        !invoiceInFo?.appointmentDetails?.physiotherapyService
                          ?.length && (
                          <tr>
                            <td colSpan="4" className="text-center">
                              No test, profile, consultation, or physiotherapy
                              data available
                            </td>
                          </tr>
                        )}
                    </>
                  )}
                </tbody>
              </table>
            </div>

            <div className="row">
              <div className="col-lg-6 col-sm-3"></div>
              <div className="col-lg-6 col-sm-9 ms-auto">
                <table className="table table-clear">
                  <tbody>
                    <tr>
                      <td className="left bold-text">Total Amount</td>
                      <td>
                        <strong>Rs: {formData?.totalAmount}</strong>
                      </td>
                    </tr>

                    {shouldHideFields &&
                      invoiceInFo?.receiptId?.discountPrice !== 0 && (
                        <tr>
                          <td className="left bold-text">Discount Amount</td>
                          <strong>
                            Rs: {invoiceInFo?.receiptId?.discountPrice}
                          </strong>
                        </tr>
                      )}

                    {shouldHideFields && (
                      <>
                        <tr>
                          <td className="left bold-text">Paid Amount</td>
                          <strong>
                            Rs:{" "}
                            {
                              invoiceInFo?.receiptId?.paymentDetails[0]
                                ?.paidAmount
                            }
                          </strong>
                        </tr>
                        <tr>
                          <td className="left bold-text">Due Amount</td>
                          <strong>
                            Rs:{" "}
                            {
                              invoiceInFo?.receiptId?.paymentDetails[0]
                                ?.dueAmount
                            }
                          </strong>
                        </tr>
                      </>
                    )}

                    {!isAllSelected &&
                      selectedRows.size === 0 &&
                      !shouldHideFields && (
                        <>
                          <tr>
                            <td
                              className="left bold-text"
                              style={{ width: "20%", verticalAlign: "top" }}
                            >
                              Discount
                            </td>
                            <td className="left" style={{ width: "70%" }}>
                              <div
                                className="d-flex align-items-center gap-2"
                                style={{ position: "relative" }}
                              >
                                <select
                                  className="form-select"
                                  name="discountType"
                                  value={formData.discountType}
                                  onChange={handleInputChange}
                                  style={{ width: "30%" }}
                                >
                                  <option value="normal">₹ (Normal)</option>
                                  <option value="percentage">
                                    % (Percentage)
                                  </option>
                                </select>

                                <input
                                  type="number"
                                  name="discount"
                                  value={formData?.discount}
                                  onChange={handleInputChange}
                                  className="form-control"
                                  style={{ width: "70%" }}
                                  placeholder={
                                    formData?.discountType === "percentage"
                                      ? "Enter %"
                                      : "Enter amount"
                                  }
                                />
                              </div>
                              {error && (
                                <p
                                  style={{
                                    color: "red",
                                    fontSize: "10px",
                                    margin: "2px 0 0",
                                  }}
                                >
                                  {error}
                                </p>
                              )}
                            </td>
                          </tr>

                          <tr>
                            <td className="left bold-text">After Discount</td>
                            <td className="right">
                              <input
                                type="text"
                                className="form-control"
                                value={formData?.totalAfterDiscount}
                                readOnly
                              />
                            </td>
                          </tr>

                          <tr>
                            <td className="left bold-text">Paid Amount</td>
                            <td className="right">
                              <input
                                type="number"
                                className="form-control"
                                name="paidAmount"
                                value={formData?.paidAmount}
                                onChange={handleInputChange}
                                onFocus={handlePaidAmountFocus}
                                min="0"
                              />
                              {paidAmountError && (
                                <p
                                  style={{
                                    color: "red",
                                    fontSize: "10px",
                                    margin: "2px 0 0",
                                  }}
                                >
                                  {paidAmountError}
                                </p>
                              )}
                            </td>
                          </tr>

                          <tr>
                            <td className="left bold-text">Due Amount</td>
                            <td className="right">
                              <input
                                type="text"
                                className="form-control"
                                value={formData?.dueAmount}
                                readOnly
                              />
                            </td>
                          </tr>
                        </>
                      )}
                    {!isAllSelected && selectedRows.size !== 0 && (
                      <tr>
                        <td className="left bold-text">Total Amount</td>
                        <td className="right">
                          <input
                            type="number"
                            className="form-control"
                            name="paidAmount"
                            value={formData?.paidAmount}
                            onChange={handleInputChange}
                          />
                          {paidAmountError && (
                            <p
                              style={{
                                color: "red",
                                fontSize: "10px",
                                margin: "2px 0 0",
                              }}
                            >
                              {paidAmountError}
                            </p>
                          )}
                        </td>
                      </tr>
                    )}

                    <tr>
                      {!(
                        invoiceInFo?.paymentStatus === "PAID" ||
                        invoiceInFo?.paymentStatus === "DUE"
                      ) && (
                        <td>
                          <Button
                            onClick={handleSubmit}
                            style={{ width: "100%", color: "white" }}
                          >
                            SUBMIT
                          </Button>
                        </td>
                      )}
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            {/* This code handles multiple invoices with headers and applies tax logic to the total amount. */}
            {allPatientInvoice?.length > 1 ? (
              <table className={styles.table}>
                <thead className={styles.tableHeader}>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        checked={isAllSelected}
                        onChange={handleHeaderChange}
                        className={styles.tableCheckbox}
                        disabled={isHeaderCheckboxDisabled}
                      />
                    </th>
                    <th>INVID</th>
                    <th>PATIENT NAME</th>
                    <th>APPID</th>
                    <th>APPT DATE</th>
                    <th>STATUS</th>
                    <th>AMOUNT</th>
                  </tr>
                </thead>
                <tbody>
                  {allPatientInvoice
                    ?.filter((row) => row?.invoiceId !== invoiceInFo?._id)
                    ?.map((row) => {
                      const details = row?.appointmentDetails || {};
                      const {
                        tests = [],
                        profiles = [],
                        healthScreeningDetails = [],
                        radioServices = [],
                        physiotherapyService = [],
                        healthPackageDetails = [],
                        hairServices = [],
                        generalServices = [],
                        skinServices = [],
                        dentalServices = [],
                        consultationDetails = [],
                      } = details;

                      let totalWithTax = 0;

                      if (healthScreeningDetails?.length > 0) {
                        const amount = Number(
                          healthScreeningDetails[0]?.healthScreeningAmount || 0
                        );
                        const tax = Number(healthScreeningDetails[0]?.tax || 0);
                        totalWithTax = amount + (amount * tax) / 100;
                      } else if (radioServices?.length > 0) {
                        totalWithTax = radioServices.reduce((sum, service) => {
                          const details =
                            service?.radiologyServiceInfo?.serviceDetails || [];
                          const serviceTotal = details.reduce(
                            (innerSum, detail) => {
                              const price = Number(detail?.price || 0);
                              const tax = Number(
                                detail?.tax || service?.tax || 0
                              ); // fallback to parent tax
                              return innerSum + price + (price * tax) / 100;
                            },
                            0
                          );

                          return sum + serviceTotal;
                        }, 0);
                      } else if (physiotherapyService?.length > 0) {
                        totalWithTax = physiotherapyService?.reduce(
                          (sum, item) => {
                            const price = Number(item?.price || 0);
                            const tax = Number(item?.tax || 0);
                            return sum + price + (price * tax) / 100;
                          },
                          0
                        );
                      } else if (healthPackageDetails?.length > 0) {
                        totalWithTax = healthPackageDetails?.reduce(
                          (sum, item) => {
                            const price = Number(
                              item?.healthPackageAmount || 0
                            );
                            const tax = Number(item?.tax || 0);
                            return sum + price + (price * tax) / 100;
                          },
                          0
                        );
                      } else if (hairServices?.length > 0) {
                        totalWithTax = hairServices?.reduce((sum, item) => {
                          const price = Number(item?.pt_price || 0);
                          const tax = Number(item?.tax || 0);
                          return sum + price + (price * tax) / 100;
                        }, 0);
                      } else if (generalServices?.length > 0) {
                        totalWithTax = generalServices?.reduce((sum, item) => {
                          const price = Number(item?.pt_price || 0);
                          const tax = Number(item?.tax || 0);
                          return sum + price + (price * tax) / 100;
                        }, 0);
                      } else if (skinServices?.length > 0) {
                        totalWithTax = skinServices?.reduce((sum, item) => {
                          const price = Number(item?.pt_price || 0);
                          const tax = Number(item?.tax || 0);
                          return sum + price + (price * tax) / 100;
                        }, 0);
                      } else if (dentalServices?.length > 0) {
                        totalWithTax = dentalServices?.reduce((sum, item) => {
                          const price = Number(item?.pt_price || 0);
                          const tax = Number(item?.tax || 0);
                          return sum + price + (price * tax) / 100;
                        }, 0);
                      } else if (consultationDetails?.length > 0) {
                        totalWithTax = consultationDetails?.reduce(
                          (sum, item) => {
                            const amount = Number(item?.price || 0);
                            return sum + amount;
                          },
                          0
                        );
                      } else {
                        const testAmountWithTax = tests?.reduce((sum, item) => {
                          const price = Number(item?.price || 0);
                          const tax = Number(item?.tax || 0);
                          return sum + price + (price * tax) / 100;
                        }, 0);

                        const profileAmountWithTax = profiles?.reduce(
                          (sum, item) => {
                            const price = Number(item?.price || 0);
                            const tax = Number(item?.tax || 0);
                            return sum + price + (price * tax) / 100;
                          },
                          0
                        );

                        totalWithTax = testAmountWithTax + profileAmountWithTax;
                      }

                      return (
                        <tr key={row.invoiceId} className={styles.tableRow}>
                          <td>
                            <input
                              type="checkbox"
                              checked={selectedRows.has(row?.invoiceId)}
                              onChange={(e) =>
                                handleRowChange(row?.invoiceId, e)
                              }
                              className={styles.tableCheckbox}
                            />
                          </td>
                          <td className={styles.tableCell}>{row?.invoiceId}</td>
                          <td className={styles.tableCell}>
                            {details?.patientName}
                          </td>
                          <td className={styles.tableCell}>
                            {details?.appointmentId}
                          </td>
                          <td className={styles.tableCell}>
                            {details?.appDate?.split("T")?.[0] || "N/A"}
                          </td>
                          <td className={styles.tableCell}>
                            {row?.paymentStatus}
                          </td>
                          <td className={styles.tableCell}>
                            {totalWithTax.toFixed(2)}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            ) : null}
            {/* end */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceForm;
